/**
 * @generated SignedSource<<f12dd8677789457d4a8bdc9dabb87c09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteIntegrationInput = {
  id: any;
};
export type RollbarIntegrationsDialogDeleteIntegrationMutation$variables = {
  input: DeleteIntegrationInput;
};
export type RollbarIntegrationsDialogDeleteIntegrationMutation$data = {
  readonly deleteIntegration: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type RollbarIntegrationsDialogDeleteIntegrationMutation = {
  response: RollbarIntegrationsDialogDeleteIntegrationMutation$data;
  variables: RollbarIntegrationsDialogDeleteIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteIntegrationPayload",
    "kind": "LinkedField",
    "name": "deleteIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RollbarIntegrationsDialogDeleteIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RollbarIntegrationsDialogDeleteIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3be0cd83a8e02d95c89a6703dfcd94ab",
    "id": null,
    "metadata": {},
    "name": "RollbarIntegrationsDialogDeleteIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation RollbarIntegrationsDialogDeleteIntegrationMutation(\n  $input: DeleteIntegrationInput!\n) {\n  deleteIntegration(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "0f0b45a486f64e02579d7f26f4507778";

export default node;
